import { useQuery } from "react-query";
import * as ajaxEndPoint from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";

const getThirdPartyCustomerInfo = async (CustomerId: number) => {
  const data = await getData(
    `${ajaxEndPoint.GET_THIRD_PARTY_CUSTOMER_DETAILS}?CustomerId=${CustomerId}`,
  );
  return data;
};

export default function useGetThirdPartyCustomerInfo(CustomerId: number) {
  return useQuery(
    [CustomerId, "getThirdPartyCustomerInfo"],
    getThirdPartyCustomerInfo,
  );
}
